import * as THREE from 'three'
import { fabric } from 'fabric'

export function getInputRefValue(input) {
	const value = input.value.value

	return value || null
}

export function clamp(num, min, max) {
	return Math.min(Math.max(num, min), max)
}

export function setControlsSize(box, canvasDisplayWidth, scale = 1) {
	const canvasScaleFactor = box.canvasWidth / (canvasDisplayWidth * scale)

	fabric.Object.prototype.cornerSize = (box.baseControlSize * canvasScaleFactor)
	fabric.Object.prototype.controls.mtr.offsetY = (box.baseRotationPointOffset * canvasScaleFactor)
}

export function generateId() {
	return Date.now().toString(36) + Math.random().toString(36).substring(2)
}

// Useful for model fixing and touchups
export function getRandomThreeJSColor() {
	// Generate random values for red, green, and blue components
	const red = Math.random()
	const green = Math.random()
	const blue = Math.random()

	// Create Three.js color object
	const color = new THREE.Color(red, green, blue)

	return color
}

export function makePanelInvisible(p) {
	p.material.forEach((mat) => {
		mat.color = new THREE.Color(0xffffff)
		mat.transparent = true
		mat.opacity = 0
	})
}

export function createElementFromHTML(htmlString) {
	const div = document.createElement('div')
	div.innerHTML = htmlString?.trim()

	return div.firstChild
}

export function normalizeValueInRange(value, minValue, maxValue) {
	if (value <= minValue) {
		return 0
	} else if (value >= maxValue) {
		return 1
	} else {
		return (value - minValue) / (maxValue - minValue)
	}
}

export function calculatePercentage(percentage, min, max) {
  // Check if min is greater than max, swap them if necessary
  if (min > max) {
    [min, max] = [max, min];
  }

  // Calculate the range between min and max
  const range = max - min;

  // Multiply the range by the percentage to get the offset from the minimum value
  const offset = range * percentage;

  // Return the value at that percentage between min and max
  return min + offset;
}

// _____________________________________________________________________________

export function getDecimalValueFromString(str) {
	return parseFloat(str.replace('_', '.'))
}

export function parseSizeString(size) {
	const parts = size.split('-')

	const [ width, length, height ] = parts.map(getDecimalValueFromString)
	return { width, length, height }
	// return `${width}" x ${length}" x ${height}"`
	// return `W:${width},L:${length},H:${height}`
}
// _____________________________________________________________________________

// @TODO find by pa slug not name
export function findAttributeValues(attributes, attributeName) {
	// // console.log('ATTRS:', attributes)
	const attribute = attributes.find((attr) => attr.name === attributeName)
	// // console.log('ATTR:', attribute)
	let options = attribute ? attribute.options : []
	if (attributeName === 'Size') {
		options = options.map(parseSizeString)
	}

	// })
	return options
}
// _____________________________________________________________________________
/**
 * Convert a query string to an object.
 * @param {string} queryString - The query string to convert.
 * @returns {object} The object representation of the query string.
 */
export function queryToObject(queryString) {
  const params = new URLSearchParams(queryString);

  // Create an object and populate it with the parameters
  const jsonObject = {};
  for (const [key, value] of params) {
    // Attempt to convert numerical values
    jsonObject[key] = isNaN(Number(value)) ? value : Number(value);
  }

  return jsonObject
}
// _____________________________________________________________________________
/**
 * Calculate the scale factor for an image to fit within a panel.
 * @param {number} panelWidth - The width of the panel.
 * @param {number} panelHeight - The height of the panel.
 * @param {number} imageWidth - The width of the image.
 * @param {number} imageHeight - The height of the image.
 * @returns {number} The scale factor for the image.
 */
export function calculateScaleFactor(panelWidth, panelHeight, imageWidth, imageHeight) {
  // Determine the orientation of the panel and image
  var panelIsLandscape = panelWidth > panelHeight;
  var imageIsLandscape = imageWidth > imageHeight;

  // Initialize scale factor
  var scaleFactor;

  // Compare orientations and determine scaling
  if (panelIsLandscape === imageIsLandscape) {
      // Same orientation: Scale based on the dimension that's relative to orientation
      if (panelIsLandscape) {
          // Both landscape
          scaleFactor = panelWidth / imageWidth;
      } else {
          // Both portrait
          scaleFactor = panelHeight / imageHeight;
      }
  } else {
      // Different orientations
      if (panelIsLandscape) {
          // Panel landscape, image portrait
          scaleFactor = panelHeight / imageHeight;
      } else {
          // Panel portrait, image landscape
          scaleFactor = panelWidth / imageWidth;
      }
  }

  return scaleFactor;
}

export function setAlphaToOne(rgbaString) {
  // Use a regular expression to match the RGBA string and capture the components
  const rgbaPattern = /rgba\((\d+),\s*(\d+),\s*(\d+),\s*(\d+|\d*\.\d+)\)/;
  const match = rgbaString.match(rgbaPattern);

  if (match) {
      // Extract the red, green, blue, and alpha components
      const red = match[1];
      const green = match[2];
      const blue = match[3];
      // Replace the alpha component with 1
      const newRgbaString = `rgba(${red}, ${green}, ${blue}, 1)`;
      return newRgbaString;
  } else {
      // Return the original string if it doesn't match the RGBA pattern
      return rgbaString;
  }
}

export function normalizePrice(price) {
  return Math.round(price * 100) / 100
}

export function formatPrice(price) {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(price)
}
